import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { clsx, Img } from '@a-type/ui';
import { useGame } from '../../hooks/useGame';
import cls from './GameTitleChatToken.module.css';
export function GameTitleChatToken({ token }) {
    const game = useGame(token.value);
    if (!game) {
        return '???';
    }
    return (_jsxs("span", { className: clsx('@mode-neutral', cls.root), children: [_jsx(Img, { fit: "cover", src: `/game-data/${game.id}/icon.png`, alt: `${game.title} icon`, className: cls.icon }), game.title] }));
}
//# sourceMappingURL=GameTitleChatToken.js.map